import { makeAutoObservable, runInAction } from "mobx";
import { authFetch, refreshAccessToken } from "../auth/auth";
import baseUrl from "../vars";
import { mergePaymentColumns } from "../components/payments_page/payment_columns";
import { innColumn, placeMissingColumns } from "../utils/report_columns";

class pageStore {
  loading = false;
  token = "";
  refresh_token = "";
  email = "";

  user = {}

  abortControllerRef = null;

  selected_page = "/";

  request_time = 0

  selectedBind = ""

  all_managers = []
  all_departments = []
  all_orgs = []
  all_agents = []
  all_agents_potential = []
  all_account_numbers = []
  all_companies = []
  all_backups = []
  report_binds = []

  all_periods = { mouths: [], years: [] }
  all_years = []

  performance = []

  start_date = ""
  end_date = ""

  selected_one_manager = ''
  selected_one_department = ''

  select_backup = ''
  // Состояние общей базы слепков: idle | restoring | ready | error.
  backup_status = 'idle'
  backup_message = ''
  backup_loaded_date = ''

  performance_data = []
  data_payments = []
  data_debitors = []
  data_potentials = []
  data_profit = []
  data_logs = []
  data_open_rev = []
  data_open_profit = []
  data_staff = []
  data_mops = []
  data_pdz = []
  data_order_suppliers = []
  data_overdue = []
  overdue_as_of = ""
  all_order_supplier_legal_entities = []
  all_order_supplier_stages = []

  // 4 поисковых фильтра отчёта «Заказ поставщику» (точное совпадение)
  os_internal_code_filter = ""
  os_payment_code_filter = ""
  os_id_deal_filter = ""
  os_account_num_1c_filter = ""
  os_legal_entity_filter = ""
  os_stage_filter = ""

  selected_view_orders = 'all'
  selected_view = 'manager-lite'
  selected_view_profit = 'manager-deals'
  selected_view_open = "all"
  selected_view_pdz = "all"

  year_or_mouth_view = 'month'
  year_or_mouth_view_mops = 'month'
  start_date_day = ''
  start_date_month = ''
  start_date_year = ''

  selected_managers = []
  selected_organization = ""

  end_date_day = ''
  end_date_month = ""
  end_date_year = ''

  selected_period = ""

  selected_one_agent = ""
  // Несколько контрагентов сразу — выбор списком в «Просроченной ДЗ».
  selected_agents = []
  selected_one_agent_potential = ""
  selected_one_account_number = ""

  selected_period_month = []
  selected_period_years = []
  select_one_company = ""

  selected_staff_years = ""

  selected_years = ""

  status_deal = "all"

  selected_type_leads = ""

  permissions = []

  roles = []

  group_by_potential = ""

  searchTermManagers = ""

  order_num_filter = ""
  order_deal_filter = ""
  order_type_date_start_filter = "none"
  order_type_date_end_filter = "none"
  order_start_open_date_filter = ""
  order_end_open_date_filter = ""
  order_start_close_date_filter = ""
  order_end_close_date_filter = ""
  order_type_dz_date_filter = "none"
  order_start_dz_date_filter = ""
  order_end_dz_date_filter = ""
  order_type_cargo_ready_filter = "none"
  order_start_cargo_ready_filter = ""
  order_end_cargo_ready_filter = ""
  order_type_date_at_client_filter = "none"
  order_start_date_at_client_filter = ""
  order_end_date_at_client_filter = ""
  order_type_shipment_date_filter = "none"
  order_start_shipment_date_filter = ""
  order_end_shipment_date_filter = ""
  order_shipment_percent_filters = {
    "0": false,
    "1-98": false,
    "50": false,
    "99": false,
    "100": false,
  }

  potential_period_deal = "none"
  potential_period_deal_start = ""
  potential_period_deal_end = ""

  isSelf = false
  isFail = false

  isReturn = false

  month_and_year_fromB24 = false
  month_and_year_fromProfit = true
  month_and_year_from1C = false


  absolute_column_profit = true
  percent_column_profit = false
  part_column_profit = false

  absolute_column_payments = true
  percent_column_payments = false
  part_column_payments = false

  absolute_column_openRev = true
  percent_column_openRev = false
  part_column_openRev = false

  absolute_column_openProfit = true
  percent_column_openProfit = false
  part_column_openProfit = false

  absolute_column_mops = true
  percent_column_mops = false
  part_column_mops = false

  workers = true

  open_filter = true

  rowHeight = 2

  formatMonthYear = (value) => {
    if (!value) return "—";

    const date =
      typeof value === "number"
        ? new Date(value < 1e12 ? value * 1000 : value)
        : new Date(value);

    if (Number.isNaN(date.getTime())) return "—";

    return new Intl.DateTimeFormat("ru-RU", {
      month: "long",
      year: "numeric",
    })
      .format(date)
      .replace(/^./, c => c.toUpperCase());
  };

  // Ширины узких столбцов — под заголовок с «⏷» шрифтом дашборда (Montserrat,
  // 1.25rem): самое длинное слово целиком и кнопка в строке с последним (21.10.2026).
  columnConfigDebitor = [
    { key: "Org", title: "Организация", width: "190px", active: true },
    { key: "Num", title: "Номер счета", width: "140px", active: true },
    { key: "Date", title: "Дата", width: "160px", active: true },
    { key: "AccOpenDate", title: "Дата открытия счета", width: "160px", active: true },
    { key: "PlanClosDate", title: "Плановая дата закрытия", width: "160px", active: true },
    { key: "ClosDate", title: "Дата закрытия", width: "160px", active: true },
    { key: "InvAmount", title: "Сумма счета", width: "180px", active: true },
    { key: "Value", title: "Валюта", width: "130px", active: true },
    { key: "RevRub", title: "Выручка в руб.", width: "220px", active: true },
    { key: "Partner", title: "Контрагент", width: "300px", active: true },
    innColumn({ width: "150px" }),
    { key: "IdDeal", title: "ID сделки", width: "150px", active: true },
    { key: "Deal", title: "Сделка", width: "350px", active: true },
    { key: "Manager", title: "Менеджер", width: "300px", active: true },
    { key: "ShipmentDate", title: "Дата отгрузки", width: "160px", active: true },
    { key: "CargoReadyDate", title: "Дата готовности груза", width: "160px", active: true },
    { key: "DeliveryDaysSpb", title: "Срок доставки (к.д.)", width: "140px", active: true },
    { key: "DateInSpb", title: "Дата в СПб", width: "160px", active: true },
    { key: "DateAtClient", title: "Дата у клиента", width: "160px", active: true },
    { key: "PostpayWorkDays", title: "Срок постоплаты (р.д.)", width: "150px", active: true },
    { key: "DzReceiveDate", title: "Дата получения ДЗ", width: "160px", active: true },
    { key: "PaidEuro", title: "Оплачено в евро", width: "160px", active: true },
    { key: "PaidRub", title: "Оплачено в руб.", width: "220px", active: true },
    { key: "PercentPayment", title: "% оплаты", width: "150px", active: true },
    { key: "DeptEuro", title: "Долг в евро", width: "180px", active: true },
    { key: "DeptRub", title: "Долг в руб.", width: "220px", active: true },
    { key: "PercentShipment", title: "% отгрузки", width: "160px", active: true },
    { key: "IsReturn", title: "Возвратный счет", width: "150px", active: true },
  ];

  columnConfigPDZ = [
    { key: "Org", title: "Организация", width: "400px", active: true },
    { key: "Manager", title: "Менеджер", width: "450px", active: true },
    { key: "DocNum", title: "Номер документа", width: "300px", active: true },
    { key: "DocDate", title: "Дата", width: "330px", active: true },
    { key: "DocSum", title: "Сумма документа", width: "200px", active: true },
    { key: "DocPresent", title: "Название", width: "650px", active: true },
    { key: "DocType", title: "Тип документа", width: "300px", active: true },
    { key: "Num", title: "Номер счета", width: "240px", active: true },
    { key: "Date", title: "Дата", width: "160px", active: true },
    { key: "AccOpenDate", title: "Дата открытия счета", width: "160px", active: true },
    { key: "PlanClosDate", title: "Плановая дата закрытия", width: "160px", active: true },
    { key: "ClosDate", title: "Дата закрытия", width: "160px", active: true },
    { key: "InvAmount", title: "Сумма счета", width: "180px", active: true },
    { key: "Value", title: "Валюта", width: "100px", active: true },
    { key: "RevRub", title: "Выручка в руб.", width: "220px", active: true },
    { key: "Partner", title: "Контрагент", width: "300px", active: true },
    { key: "IdDeal", title: "ID сделки", width: "240px", active: true, isLink: true, linkTemplate: "https://alforest.bitrix24.ru/crm/deal/details/{value}/" },
    { key: "Deal", title: "Сделка", width: "350px", active: true, isLink: true, linkTemplate: "https://alforest.bitrix24.ru/crm/deal/details/{IdDeal}/" },
    { key: "PaidEuro", title: "Оплачено в евро", width: "160px", active: true },
    { key: "PaidRub", title: "Оплачено в руб.", width: "220px", active: true },
    { key: "PercentPayment", title: "% оплаты", width: "120px", active: true },
    { key: "DeptEuro", title: "Долг в евро", width: "180px", active: true },
    { key: "DeptRub", title: "Долг в руб.", width: "220px", active: true },
    { key: "PercentShipment", title: "% отгрузки", width: "120px", active: true },
    { key: "IsReturn", title: "Возвратный счет", width: "120px", active: true },
    { key: "planProfit", title: "План. прибыль", width: "150px", active: true },
    { key: "planRent", title: "План. рент.", width: "150px", active: true },
  ];

  columnConfigOpenRev = [
    { key: "Org", title: "Организация", width: "150px", active: true },
    { key: "Num", title: "Номер счета", width: "140px", active: true },
    { key: "Date", title: "Дата", width: "160px", active: true },
    { key: "AccOpenDate", title: "Дата открытия счета", width: "160px", active: true },
    { key: "PlanClosDate", title: "Плановая дата закрытия", width: "160px", active: true },
    { key: "ClosDate", title: "Дата закрытия", width: "160px", active: true },
    { key: "InvAmount", title: "Сумма счета", width: "180px", active: true },
    { key: "Value", title: "Валюта", width: "100px", active: true },
    { key: "RevRub", title: "Выручка в руб.", width: "220px", active: true },
    { key: "Partner", title: "Контрагент", width: "300px", active: true },
    { key: "IdDeal", title: "ID сделки", width: "120px", active: true },
    { key: "Deal", title: "Сделка", width: "350px", active: true },
    { key: "Manager", title: "Менеджер", width: "300px", active: true },
    { key: "PaidEuro", title: "Оплачено в евро", width: "160px", active: true },
    { key: "PaidRub", title: "Оплачено в руб.", width: "220px", active: true },
    { key: "PercentPayment", title: "% оплаты", width: "120px", active: true },
    { key: "DeptEuro", title: "Долг в евро", width: "180px", active: true },
    { key: "DeptRub", title: "Долг в руб.", width: "220px", active: true },
    { key: "PercentShipment", title: "% отгрузки", width: "120px", active: true },
    { key: "IsReturn", title: "Возвратный счет", width: "120px", active: true },
    { key: "LeftTotal", title: "Итого слева", active: true },
    { key: "LeftAvgTotal", title: "Итого ср. слева", active: true },
    { key: "RightTotal", title: "Итого справа", active: true },
    { key: "RightAvgTotal", title: "Итого ср. справа", active: true },
  ];

  columnConfigOpenProfit = [
    { key: "Org", title: "Организация", width: "150px", active: true },
    { key: "Num", title: "Номер счета", width: "140px", active: true },
    { key: "Date", title: "Дата", width: "160px", active: true },
    { key: "AccOpenDate", title: "Дата открытия счета", width: "160px", active: true },
    { key: "PlanClosDate", title: "Плановая дата закрытия", width: "160px", active: true },
    { key: "ClosDate", title: "Дата закрытия", width: "160px", active: true },
    { key: "InvAmount", title: "Сумма счета", width: "180px", active: true },
    { key: "Value", title: "Валюта", width: "100px", active: true },
    { key: "planProfit", title: "Планируемая прибыль", width: "220px", active: true },
    { key: "Partner", title: "Контрагент", width: "300px", active: true },
    innColumn({ width: "150px" }),
    { key: "IdDeal", title: "ID сделки", width: "120px", active: true },
    { key: "Deal", title: "Сделка", width: "350px", active: true },
    { key: "Manager", title: "Менеджер", width: "300px", active: true },
    { key: "PaidEuro", title: "Оплачено в евро", width: "160px", active: true },
    { key: "PaidRub", title: "Оплачено в руб.", width: "220px", active: true },
    { key: "PercentPayment", title: "% оплаты", width: "120px", active: true },
    { key: "DeptEuro", title: "Долг в евро", width: "180px", active: true },
    { key: "DeptRub", title: "Долг в руб.", width: "220px", active: true },
    { key: "PercentShipment", title: "% отгрузки", width: "120px", active: true },
    { key: "IsReturn", title: "Возвратный счет", width: "120px", active: true },
    { key: "planProfitYear", title: "План. прибыль год", width: "220px", active: true, isNumeric: true },
    { key: "planYearLambda", title: "Отклонение год", width: "220px", active: true, isNumeric: true },
    { key: "planProfitPeriod", title: "План. прибыль период", width: "220px", active: true, isNumeric: true },
    { key: "planPeriodLambda", title: "Отклонение периода", width: "220px", active: true, isNumeric: true },
    { key: "LeftTotal", title: "Итого слева", active: true },
    { key: "LeftAvgTotal", title: "Итого ср. слева", active: true },
    { key: "RightTotal", title: "Итого справа", active: true },
    { key: "RightAvgTotal", title: "Итого ср. справа", active: true },
  ];

  columnConfigPotential = [
    { key: "fio", title: "Менеджер", active: true },
    { key: "name", title: "Клиент", active: true },
    innColumn(),
    { key: "UF_CRM_1473868262", title: "Производитель", active: true },
    {
      key: "ID",
      title: "ID сделки",
      isLink: true,
      linkTemplate: "https://alforest.bitrix24.ru/crm/deal/details/{value}/",
      active: true
    },
    { key: "TITLE", title: "Название сделки", active: true },
    { key: "UF_CRM_1486711068", title: "Номер счета", active: true },
    { key: "AccOpenDate", title: "Дата открытия счета", active: true },
    { key: "ClosDate", title: "Дата закрытия", active: true },
    { key: "promo_name", title: "Рекламная кампания", active: true},
    { key: "lead_type", title: "Тип лида", active: true},
    { key: "RevRub", title: "Выручка в рублях", isNumeric: true, active: true },
    { key: "PaidRub", title: "Оплата факт.", isNumeric: true, active: true },
    { key: "profit", title: "Прибыль факт. закрыто", isNumeric: true, active: true },
    { key: "profitabilityFact", title: "Рентабельность факт.%", isNumeric: true, isPercentage: true, active: true },
    { key: "openProfitValue", title: "Прибыль открытых сделок", isNumeric: true, active: true },
    { key: "profitabilityOpen", title: "Рентабельность откр.%", isNumeric: true, isPercentage: true, active: true },
    { key: "profitInCash", title: "Прибыль в кассе", isNumeric: true, active: true },
    { key: "openProfit", title: "Прибыль ещё ожидаемая", isNumeric: true, active: true },
    { key: "totalProfit", title: "Общая прибыль", isNumeric: true, active: true },
  ];

  static TYPE_MAPPING = {
    2: "Запчасти Металлобработка",
    SALE: "Запчасти ЛПК",
    GOODS: "Другие жидкости",
    COMPLEX: "Инструмент режущий",
    6: "Цепи тяговые, транспортерные",
    7: "Другое",
    SERVICE: "Оборудование",
  };

  static TYPE_LEAD = {
    "2638": "Исходящий лид",
    "2636": "Входящий лид",
  }


  static TYPE_MONTHS = {
    "122623": "Сделка не закрыта",
    "4278": "01_Январь",
    "4280": "02_Февраль",
    "4282": "03_Март",
    "4284": "04_Апрель",
    "4286": "05_Май",
    "4288": "06_Июнь",
    "4290": "07_Июль",
    "4292": "08_Август",
    "4294": "09_Сентябрь",
    "4296": "10_Октябрь",
    "4298": "11_Ноябрь",
    "4300": "12_Декабрь"
  }

  static TYPE_YEARS = {
    "122629": "Сделка не закрыта",
    "4302": "2017",
    "4304": "2018",
    "4306": "2019",
    "4308": "2020",
    "122611": "2021",
    "134821": "2022",
    "153037": "2023",
    "153039": "2024",
    "483623": "2025",
    "483625": "2026",
    "483627": "2027",
    "483629": "2028"
  }


  columnConfigProfit = [
    {
      key: "ID",
      title: "ID сделки",
      isLink: true,
      linkTemplate: "https://alforest.bitrix24.ru/crm/deal/details/{value}/",
      active: true
    },
    {
      key: "UF_CRM_1484134192",
      title: "ID лида",
      isLink: true,
      linkTemplate: "https://alforest.bitrix24.ru/crm/lead/details/{value}/",
      active: true
    },
    { key: "name", title: "Компания", active: true },
    { key: "revenue", title: "Оборот, млн. ", isNumeric: true, active: true },
    { key: "TITLE", title: "Название сделки", active: true },
    { key: "fio", title: "Ответственный", active: true },
    { key: "UF_CRM_1473868262", title: "Производитель", active: true },
    { key: "UF_CRM_1486711068", title: "Номер счета 1С", active: true },
    { key: "UF_CRM_1490282792", title: "Год закрытия", active: true, format: (value) => pageStore.TYPE_YEARS[value] || value },
    { key: "UF_CRM_1490281786", title: "Месяц закрытия", active: true, format: (value) => pageStore.TYPE_MONTHS[value] || value },
    {
      key: "closdate", title: "Месяц и год закрытия (учтено)", active: true,
      format: this.formatMonthYear
    },
    { key: "AccOpenDate", title: "Дата открытия счета", active: true },
    { key: "ClosDate", title: "Дата закрытия счета", active: true },
    { key: "IsReturn", title: "Возвратный счёт", active: true },
    { key: "UF_CRM_580D99FA127E8", title: "Тип лида", active: true, format: (value) => pageStore.TYPE_LEAD[value] || value },
    { key: "UF_CRM_580D99FA1DC2F", title: "Рекламная кампания", active: true },
    {
      key: "TYPE_ID",
      title: "Тип",
      format: (value) => pageStore.TYPE_MAPPING[value] || value,
      active: true,
    },
    { key: "RevRub", title: "Выручка, руб.", isNumeric: true, active: true },
    { key: "profit", title: "Прибыль 1 (М)", isNumeric: true, active: true },
  ];

  columnConfigPayments = mergePaymentColumns();

  columnConfigStaff = [
    { key: "departament", title: "Отдел", active: true },
    { key: "fio", title: "ФИО", active: true },
    { key: "employment", title: "Дата приема на работу", active: true },
    { key: "experience_month", title: "Стаж (мес.)", active: true },
    { key: "experience_year", title: "Стаж (лет)", active: true },
  ]

  // «Просроченная ДЗ (ПДЗ)» — те же столбцы, что у инструмента в Б24.
  columnConfigOverdue = [
    { key: "Partner", title: "Компания", width: "220px", active: true },
    { key: "Manager", title: "Менеджер", width: "180px", active: true },
    {
      key: "IdDeal",
      title: "ID сделки",
      width: "100px",
      active: true,
      isLink: true,
      linkTemplate: "https://alforest.bitrix24.ru/crm/deal/details/{value}/",
    },
    {
      key: "DealTitle",
      title: "Название сделки",
      width: "320px",
      active: true,
      isLink: true,
      linkField: "IdDeal",
      linkTemplate: "https://alforest.bitrix24.ru/crm/deal/details/{value}/",
    },
    { key: "Num", title: "Номер счёта", width: "130px", active: true },
    { key: "DzReceiveDate", title: "Дата оплаты по договору", width: "110px", active: true },
    // Долг за отгруженное: «Долг в руб.» × «% отгрузки» (считает backend).
    { key: "OverdueRub", title: "Сумма ПДЗ, руб.", width: "150px", active: true },
    { key: "OverdueDays", title: "Календ. дней просрочки", width: "120px", active: true },
  ];

  columnConfigOrderSuppliers = [
    // --- основные (активны по умолчанию) ---
    { key: "BeginDate",         title: "Дата начала",         width: "100px", active: true },
    {
      key: "ID",
      title: "ID",
      width: "100px",
      active: true,
      isLink: true,
      linkTemplate: "https://alforest.bitrix24.ru/crm/type/1040/details/{value}/",
    },
    {
      key: "IdDeal",
      title: "ID сделки",
      width: "120px",
      active: true,
      isLink: true,
      linkTemplate: "https://alforest.bitrix24.ru/crm/deal/details/{value}/",
    },
    {
      key: "Title",
      title: "Название",
      width: "250px",
      active: true,
      isLink: true,
      linkField: "ID",
      linkTemplate: "https://alforest.bitrix24.ru/crm/type/1040/details/{value}/",
    },
    { key: "Manager",           title: "Ответственный",       width: "130px", active: true },
    { key: "Stage",             title: "Стадия",              width: "100px", active: true },
    { key: "Brands",            title: "Список названий брендов", width: "120px", active: true },
    { key: "LegalEntity",       title: "Наше юрлицо",         width: "100px", active: true },
    { key: "AccountNum1C",      title: "Номер счета из 1С",   width: "90px", active: true },
    { key: "AccountNumPartner", title: "Номер счета партнёра", width: "90px", active: true },
    { key: "InternalCode",      title: "Внутренний код",      width: "90px", active: true },
    { key: "PaymentCodeB24",    title: "Код оплаты в Б24",    width: "90px", active: true },

    // --- расширенный набор UF-полей (скрыты по умолчанию, включаются через "Выбрать колонки") ---
    { key: "PurchaseCountry",   title: "Страна закупки",      width: "90px", active: false },
    { key: "DealPassport",      title: "Паспорт сделки",      width: "90px", active: false },
    { key: "InvoiceNumber",     title: "Номер инвойса",       width: "90px", active: false },
    { key: "InvoiceDate",       title: "Дата инвойса",        width: "90px", active: false },
    { key: "PurchaseAmount",    title: "Сумма закупки",       width: "100px", active: false, isNumeric: true },
    { key: "PurchaseCurrency",  title: "Валюта",              width: "80px",  active: false },
    { key: "PaymentChannel",    title: "Канал оплаты",        width: "100px", active: false },
    { key: "PaymentDate1",      title: "Дата оплаты плечо 1", width: "100px", active: false },
    { key: "PaymentDate2",      title: "Дата оплаты плечо 2", width: "100px", active: false },
    { key: "CargoReadyDate",    title: "Дата готовности груза", width: "100px", active: false },
    { key: "ArrivalConsolDate", title: "Дата прибытия на склад консолидации", width: "90px", active: false },
    { key: "ArrivalSpbDate",    title: "Дата прибытия в СПб", width: "100px", active: false },
    { key: "AlreadyLinked",     title: "Уже привязывался",    width: "100px", active: false },
    { key: "Comment",           title: "Комментарий",         width: "100px", active: false },
    {
      key: "TaskUrl",
      title: "Ссылка на задачу",
      width: "100px",
      active: false,
      isLink: true,
      linkTemplate: "{value}",
    },
    { key: "CloseDate",         title: "Дата завершения",     width: "100px", active: false },
    { key: "MovedTime",         title: "Дата изменения стадии", width: "100px", active: false },
    { key: "CategoryId",        title: "Воронка (ID)",        width: "100px", active: false },
    { key: "SupplierId",        title: "Поставщик (ID)",      width: "100px", active: false },
    { key: "CreatedTime",       title: "Когда создан",        width: "100px", active: false },
    { key: "UpdatedTime",       title: "Когда обновлён",      width: "100px", active: false },
  ]

  // Отчёт "mops" исторически переиспользовал колонки openRev — заведён отдельный
  // конфиг, чтобы видимость/порядок колонок не расшаривались между отчётами.
  columnConfigMops = [
    { key: "Org", title: "Организация", width: "150px", active: true },
    { key: "Num", title: "Номер счета", width: "140px", active: true },
    { key: "Date", title: "Дата", width: "160px", active: true },
    { key: "AccOpenDate", title: "Дата открытия счета", width: "160px", active: true },
    { key: "PlanClosDate", title: "Плановая дата закрытия", width: "160px", active: true },
    { key: "ClosDate", title: "Дата закрытия", width: "160px", active: true },
    { key: "InvAmount", title: "Сумма счета", width: "180px", active: true },
    { key: "Value", title: "Валюта", width: "100px", active: true },
    { key: "RevRub", title: "Выручка в руб.", width: "220px", active: true },
    { key: "Partner", title: "Контрагент", width: "300px", active: true },
    { key: "IdDeal", title: "ID сделки", width: "120px", active: true },
    { key: "Deal", title: "Сделка", width: "350px", active: true },
    { key: "Manager", title: "Менеджер", width: "300px", active: true },
    { key: "PaidEuro", title: "Оплачено в евро", width: "160px", active: true },
    { key: "PaidRub", title: "Оплачено в руб.", width: "220px", active: true },
    { key: "PercentPayment", title: "% оплаты", width: "120px", active: true },
    { key: "DeptEuro", title: "Долг в евро", width: "180px", active: true },
    { key: "DeptRub", title: "Долг в руб.", width: "220px", active: true },
    { key: "PercentShipment", title: "% отгрузки", width: "120px", active: true },
    { key: "IsReturn", title: "Возвратный счет", width: "120px", active: true },
    { key: "LeftTotal", title: "Итого слева", active: true },
    { key: "LeftAvgTotal", title: "Итого ср. слева", active: true },
    { key: "RightTotal", title: "Итого справа", active: true },
    { key: "RightAvgTotal", title: "Итого ср. справа", active: true },
  ]

  columns = {
    "openRev": this.columnConfigOpenRev,
    "openProfit": this.columnConfigOpenProfit,
    "debitor": this.columnConfigDebitor,
    "potential": this.columnConfigPotential,
    "profit": this.columnConfigProfit,
    "payments": this.columnConfigPayments,
    "staff": this.columnConfigStaff,
    "orderSuppliers": this.columnConfigOrderSuppliers,
    "mops": this.columnConfigMops,
    "overdue": this.columnConfigOverdue,
  }

  constructor() {
    makeAutoObservable(this);
  }

  setLoading(value) {
    this.loading = value
  }

  updateToken = (new_token) => {
    this.token = new_token;
  }

  updateRefreshToken = (new_token) => {
    this.refresh_token = new_token;
  }
  updateEmail = (new_email) => {
    this.email = new_email;
  }

  updateUser = (new_user) => {
    this.user = new_user;
  }

  updateSelectedPage = (new_page) => {
    this.selected_page = new_page
  }

  updateStartDate = (new_date) => {
    this.start_date = new_date;
  }
  updateEndDate = (new_date) => {
    this.end_date = new_date
  }

  updateSelectedOneManager = (new_man) => {
    this.selected_one_manager = new_man
  }
  updateSelectedOneDepartment = (new_dep) => {
    this.selected_one_department = new_dep || "";
    this.getAllManagers().catch(error => console.error("Ошибка при получении менеджеров:", error));
  }

  updatePerformanceData = (new_data) => {
    this.performance_data = new_data;
  }

  updateSelectedView = (new_view) => {
    this.selected_view = new_view
  }
  updateSelectedViewProfit = (new_view) => {
    this.selected_view_profit = new_view
  }
  updateSelectedViewOrders = (new_view) => {
    this.selected_view_orders = new_view
  }
  updateSelectedViewPDZ = (new_view) => {
    this.selected_view_pdz = new_view
  }
  updateSelectedViewOpen = (new_view) => {
    this.selected_view_open = new_view
  }
  updateYearOrMouthView = (new_view) => {
    this.year_or_mouth_view = new_view
  }
  updateYearOrMouthViewMOPS = (new_view) => {
    this.year_or_mouth_view_mops = new_view
  }
  // Пресет периода пришёл из сохранённой настройки — пересчитывать даты
  // «от сегодня» нельзя, иначе сохранённый период затирается (см. эффект
  // в select_period.jsx). Любой клик по кнопке периода сбрасывает флаг.
  period_from_bind = false

  clearPeriodFromBind = () => {
    this.period_from_bind = false
  }

  updateSelectedPeriod = (new_per, source = "") => {
    this.period_from_bind = source === "bind"
    this.selected_period = new_per
  }
  updateStartDateMonth = (new_date) => {
    this.start_date_month = new_date
  }
  updateEndDateMonth = (new_date) => {
    this.end_date_month = new_date
  }

  updateStartDateDay = (new_date) => {
    this.start_date_day = new_date
  }
  updateEndDateDay = (new_date) => {
    this.end_date_day = new_date
  }

  updateEndDateYear = (new_date) => {
    this.end_date_year = new_date
  }
  updateStartDateYear = (new_date) => {
    this.start_date_year = new_date
  }

  updateSelectedManagers = (new_managers) => {
    this.selected_managers = new_managers;
  }

  updateSelectedOrganiztion = (new_org) => {
    this.selected_organization = new_org
  }

  updateSelectedAgents = (agents) => {
    this.selected_agents = agents || [];
  }
  updateSelectedAgent = (new_agent) => {
    this.selected_one_agent = new_agent
  }
  updateSelectedAgentPotential = (new_agent) => {
    this.selected_one_agent_potential = new_agent
  }
  updateSelectedAccountNumber = (new_num) => {
    this.selected_one_account_number = new_num;
  }

  updateSelectedPeriodMonth = (new_month) => {
    this.selected_period_month = new_month;
  }
  updateSelectedCompany = (new_company) => {
    this.select_one_company = new_company;
  }

  updateSelectedStaffYears = (new_staff_years) => {
    this.selected_staff_years = new_staff_years
  }

  updateDataPayments = (new_payments) => {
    this.data_payments = new_payments
  }
  updateDataDebitors = (new_deb) => {
    this.data_debitors = new_deb;
  }

  updateDataPDZ = (new_pdz) => {
    this.data_pdz = new_pdz
  }

  updateSelectedBackup = (new_backup) => {
    this.select_backup = new_backup;
    if (!new_backup) {
      this.backup_status = 'idle';
      this.backup_message = '';
      return;
    }
    this.backup_status = 'restoring';
    this.backup_message = 'Готовим слепок…';
    this.updateSelectedBackupServer()
      .then(state => this.applyBackupStatus(state))
      .then(() => this.waitForBackup())
      .catch(error => runInAction(() => {
        this.backup_status = 'error';
        this.backup_message = error?.message || 'Не удалось подготовить слепок';
      }));
  }

  /** Раскладывает ответ сервера о слепке по наблюдаемым полям. */
  applyBackupStatus = (state) => {
    if (!state) return;
    runInAction(() => {
      this.backup_status = state.status || 'idle';
      this.backup_loaded_date = state.date || '';
      this.backup_message = state.error
        || state.message
        || (state.status === 'restoring' ? 'Готовим слепок…' : '');
    });
  }

  /**
   * Ждёт, пока слепок развернётся.
   *
   * Восстановление занимает около минуты и идёт в фоне на сервере, поэтому
   * опрашиваем состояние, а не держим один долгий запрос: иначе он упрётся
   * в таймаут прокси, а пользователь так и не узнает, чем всё кончилось.
   */
  waitForBackup = async (timeoutMs = 5 * 60 * 1000) => {
    const deadline = Date.now() + timeoutMs;
    while (Date.now() < deadline) {
      const state = await this.getBackupStatus();
      if (state?.status !== 'restoring') return state;
      await new Promise(resolve => setTimeout(resolve, 2000));
    }
    runInAction(() => {
      this.backup_status = 'error';
      this.backup_message = 'Слепок готовится слишком долго. Попробуйте позже.';
    });
    return null;
  }

  getBackupStatus = async () => {
    const response = await authFetch(`${baseUrl}/api/backup_status`, {
      method: "GET",
      headers: { accept: "application/json" },
    });
    const state = await response.json();
    this.applyBackupStatus(state);
    return state;
  }

  updateGroupByPotential = (new_pot) => {
    this.group_by_potential = new_pot
  }
  clearDataPayments = () => {
    this.data_payments = [];
  };
  clearDataDebitors = () => {
    this.data_debitors = [];
  };
  clearDataProfit = () => {
    this.data_profit = [];
  };
  clearDataPotentials = () => {
    this.data_potentials = [];
  };
  clearDataOpenRev = () => {
    this.data_open_rev = [];
  }
  clearDataOpenProfit = () => {
    this.data_open_profit = [];
  }
  clearDataStaff = () => {
    this.data_staff = [];
  }
  clearDataMops = () => {
    this.data_mops = [];
  }
  clearDataPDZ = () => {
    this.data_pdz = [];
  }


  addDataPayments = (newPayments) => {
    this.data_payments = [...this.data_payments, ...newPayments];
  };
  addDataDebitors = (newDebitors) => {
    this.data_debitors = [...this.data_debitors, ...newDebitors];
  };
  addDataPotential = (newPotential) => {
    this.data_potentials = [...this.data_potentials, ...newPotential];
  };
  addDataOpenRev = (newOpen) => {
    this.data_open_rev = [...this.data_open_rev, ...newOpen];
  };
  addDataOpenProfit = (newOpen) => {
    this.data_open_profit = [...this.data_open_profit, ...newOpen];
  }
  addDataMops = (newMops) => {
    this.data_mops = [...this.data_mops, ...newMops];
  }
  addDataStaff = (newStaff) => {
    this.data_staff = [...this.data_staff, ...newStaff];
  }
  addDataPDZ = (newPDZ) => {
    this.data_pdz = [...this.data_pdz, ...newPDZ]
  }
  updateSelectedPeriodYear = (new_per) => {
    this.selected_period_years = new_per
  }

  updateSelectedYears = (new_years) => {
    this.selected_years = new_years;
  }

  updateStatusDeal = (new_deal) => {
    this.status_deal = new_deal;
  }

  updateDataPotentials = (new_pot) => {
    this.data_potentials = new_pot;
  }

  updateSelectedTypeLeads = (new_type) => {
    this.selected_type_leads = new_type;
  }

  updateDataProfit = (new_prof) => {
    this.data_profit = new_prof;
  }
  addDataProfit = (new_prof) => {
    this.data_profit = [...this.data_profit, ...new_prof];;
  }
  updatePermissions = (new_perm) => {
    this.permissions = new_perm;
  }

  setIsSelf(value, type = "") {
    if (type == "bind") {
      this.isSelf = value
    } else {
      this.isSelf = this.isSelf === true ? false : true
    }
  }
  setIsFail(value, type = "") {
    if (type == "bind") {
      this.isFail = value
    } else {
      this.isFail = this.isFail === true ? false : true
    }
  }
  setIsReturn(value, type = "") {
    if (type == "bind") {
      this.isReturn = value
    } else {
      this.isReturn = this.isReturn === true ? false : true
    }
  }
  setOrderNumFilter(value) {
    this.order_num_filter = value
  }
  setOrderDealFilter(value) {
    this.order_deal_filter = value
  }
  setOrderTypeDateStartFilter(value) {
    this.order_type_date_start_filter = value
  }

  setPotentialPeriodDeal(value) {
    this.potential_period_deal = value
  }

  setPotentialPeriodDealStart(value) {
    this.potential_period_deal_start = value
  }

  setPotentialPeriodDealEnd(value) {
    this.potential_period_deal_end = value
  }

  setOrderTypeDateEndFilter(value) {
    this.order_type_date_end_filter = value
  }
  setOrderTypeDzDateFilter(value) {
    this.order_type_dz_date_filter = value
  }
  setOrderStartDzDateFilter(value) {
    this.order_start_dz_date_filter = this.toISODateString(value)
    if (this.order_start_dz_date_filter && !this.order_end_dz_date_filter) {
      this.setOrderEndDzDateFilter(new Date())
    }
  }
  setOrderEndDzDateFilter(value) {
    this.order_end_dz_date_filter = this.toISODateString(value)
  }
  setOrderTypeCargoReadyFilter(value) {
    this.order_type_cargo_ready_filter = value
  }
  setOrderStartCargoReadyFilter(value) {
    this.order_start_cargo_ready_filter = this.toISODateString(value)
    if (this.order_start_cargo_ready_filter && !this.order_end_cargo_ready_filter) {
      this.setOrderEndCargoReadyFilter(new Date())
    }
  }
  setOrderEndCargoReadyFilter(value) {
    this.order_end_cargo_ready_filter = this.toISODateString(value)
  }
  setOrderTypeDateAtClientFilter(value) {
    this.order_type_date_at_client_filter = value
  }
  setOrderStartDateAtClientFilter(value) {
    this.order_start_date_at_client_filter = this.toISODateString(value)
    if (this.order_start_date_at_client_filter && !this.order_end_date_at_client_filter) {
      this.setOrderEndDateAtClientFilter(new Date())
    }
  }
  setOrderEndDateAtClientFilter(value) {
    this.order_end_date_at_client_filter = this.toISODateString(value)
  }
  setOrderTypeShipmentDateFilter(value) {
    this.order_type_shipment_date_filter = value
  }
  setOrderStartShipmentDateFilter(value) {
    this.order_start_shipment_date_filter = this.toISODateString(value)
    if (this.order_start_shipment_date_filter && !this.order_end_shipment_date_filter) {
      this.setOrderEndShipmentDateFilter(new Date())
    }
  }
  setOrderEndShipmentDateFilter(value) {
    this.order_end_shipment_date_filter = this.toISODateString(value)
  }
  setOrderShipmentPercentFilter(key, checked) {
    this.order_shipment_percent_filters = {
      ...this.order_shipment_percent_filters,
      [key]: !!checked,
    }
  }
  setOrderShipmentPercentFilters(value) {
    this.order_shipment_percent_filters = {
      "0": false,
      "1-98": false,
      "50": false,
      "99": false,
      "100": false,
      ...(value || {}),
    }
  }
  setOrderStartOpenDateFilter(value) {
    this.order_start_open_date_filter = this.toISODateString(value)
    if (!this.order_end_open_date_filter) {
      this.setOrderEndOpenDateFilter(new Date())
    }
  }
  setMonthAndYearFromB24(value, type = "") {
    if (type == "bind") {
      this.month_and_year_fromB24 = value
    } else {
      this.month_and_year_fromB24 = this.month_and_year_fromB24 === true ? false : true
    }
  }
  setMonthAndYearFromProfit(value, type = "") {
    if (type == "bind") {
      this.month_and_year_fromProfit = value
    } else {
      this.month_and_year_fromProfit = this.month_and_year_fromProfit === true ? false : true
    }
  }
  setMonthAndYearFrom1C(value, type = "") {
    if (type == "bind") {
      this.month_and_year_from1C = value
    } else {
      this.month_and_year_from1C = this.month_and_year_from1C === true ? false : true
    }
  }
  setAbsoluteColumnProfit(value, type = "") {
    if (type == "bind") {
      this.absolute_column_profit = value
    } else {
      this.absolute_column_profit = this.absolute_column_profit === true ? false : true
    }
  }
  setPercentColumnProfit(value, type = "") {
    if (type == "bind") {
      this.percent_column_profit = value
    } else {
      this.percent_column_profit = this.percent_column_profit === true ? false : true
    }
  }
  setPartColumnProfit(value, type = "") {
    if (type == "bind") {
      this.part_column_profit = value
    } else {
      this.part_column_profit = this.part_column_profit === true ? false : true
    }
  }
  setAbsoluteColumnPayments(value, type = "") {
    if (type == "bind") {
      this.absolute_column_payments = value
    } else {
      this.absolute_column_payments = this.absolute_column_payments === true ? false : true
    }
  }
  setPercentColumnPayments(value, type = "") {
    if (type == "bind") {
      this.percent_column_payments = value
    } else {
      this.percent_column_payments = this.percent_column_payments === true ? false : true
    }
  }
  setPartColumnPayments(value, type = "") {
    if (type == "bind") {
      this.part_column_payments = value
    } else {
      this.part_column_payments = this.part_column_payments === true ? false : true
    }
  }
  setAbsoluteColumnOpenRev(value, type = "") {
    if (type == "bind") {
      this.absolute_column_openRev = value
    } else {
      this.absolute_column_openRev = this.absolute_column_openRev === true ? false : true
    }
  }
  setPercentColumnOpenRev(value, type = "") {
    if (type == "bind") {
      this.percent_column_openRev = value
    } else {
      this.percent_column_openRev = this.percent_column_openRev === true ? false : true
    }
  }
  setPartColumnOpenRev(value, type = "") {
    if (type == "bind") {
      this.part_column_openRev = value
    } else {
      this.part_column_openRev = this.part_column_openRev === true ? false : true
    }
  }
  setAbsoluteColumnOpenProfit(value, type = "") {
    if (type == "bind") {
      this.absolute_column_openProfit = value
    } else {
      this.absolute_column_openProfit = this.absolute_column_openProfit === true ? false : true
    }
  }
  setPercentColumnOpenProfit(value, type = "") {
    if (type == "bind") {
      this.percent_column_openProfit = value
    } else {
      this.percent_column_openProfit = this.percent_column_openProfit === true ? false : true
    }
  }
  setPartColumnOpenProfit(value, type = "") {
    if (type == "bind") {
      this.part_column_openProfit = value
    } else {
      this.part_column_openProfit = this.part_column_openProfit === true ? false : true
    }
  }
  setAbsoluteColumnMops(value, type = "") {
    if (type == "bind") {
      this.absolute_column_mops = value
    } else {
      this.absolute_column_mops = this.absolute_column_mops === true ? false : true

    }
  }
  setPercentColumnMops(value, type = "") {
    if (type == "bind") {
      this.percent_column_mops = value
    } else {
      this.percent_column_mops = this.percent_column_mops === true ? false : true
    }
  }
  setPartColumnMops(value, type = "") {
    if (type == "bind") {
      this.part_column_mops = value
    } else {
      this.part_column_mops = this.part_column_mops === true ? false : true
    }
  }

  setWorkers(value, type = "") {
    if (type == "bind") {
      this.workers = value
    } else {
      this.workers = this.workers === true ? false : true
    }
  }

  setOpenFilters(value, type = "") {
    if (type == "bind") {
      this.open_filter = value
    } else {
      this.open_filter = this.open_filter === true ? false : true
    }
  }

  setRowHeight(value) {
    this.rowHeight = value
  }

  setColumnConfigDebitor(value) {
    this.columnConfigDebitor = value
    this.editActiveColumns("debitor", value);
  }
  setColumnConfigOpenRev(value) {
    this.columnConfigOpenRev = value
    this.editActiveColumns("openRev", value);
  }
  setColumnConfigOpenProfit(value) {
    this.columnConfigOpenProfit = value;
    this.editActiveColumns("openProfit", value)
  }
  setColumnConfigPotential(value) {
    this.columnConfigPotential = value
    this.editActiveColumns("potential", value);
  }
  setColumnConfigProfit(value) {
    this.columnConfigProfit = value
    this.editActiveColumns("profit", value);
  }
  setColumnConfigPayments(value) {
    this.columnConfigPayments = mergePaymentColumns(value)
    this.editActiveColumns("payments", this.columnConfigPayments);
  }
  setColumnConfigStaff(value) {
    this.columnConfigStaff = value
    this.editActiveColumns("staff", value);
  }
  setColumnConfigPDZ(value) {
    this.columnConfigPDZ = value
    this.editActiveColumns("pdz", value);
  }
  setColumnConfigOrderSuppliers(value) {
    this.columnConfigOrderSuppliers = value
    this.editActiveColumns("orderSuppliers", value);
  }
  setColumnConfigOverdue(value) {
    this.columnConfigOverdue = value
    this.editActiveColumns("overdue", value);
  }
  clearDataOverdue() {
    this.data_overdue = []
    this.overdue_as_of = ""
  }
  setDataOverdue(arr, asOf) {
    this.data_overdue = arr || []
    this.overdue_as_of = asOf || ""
  }
  setColumnConfigMops(value) {
    this.columnConfigMops = value
    this.editActiveColumns("mops", value);
  }

  // --- сеттеры фильтров отчёта «Заказ поставщику» ---
  setOsInternalCodeFilter(value)   { this.os_internal_code_filter   = value }
  setOsPaymentCodeFilter(value)    { this.os_payment_code_filter    = value }
  setOsIdDealFilter(value)         { this.os_id_deal_filter         = value }
  setOsAccountNum1CFilter(value)   { this.os_account_num_1c_filter  = value }
  setOsLegalEntityFilter(value)    { this.os_legal_entity_filter    = value }
  setOsStageFilter(value)          { this.os_stage_filter           = value }

  clearDataOrderSuppliers() {
    this.data_order_suppliers = []
  }
  addDataOrderSuppliers(arr) {
    this.data_order_suppliers = [...this.data_order_suppliers, ...(arr || [])]
  }

  setSearchTermManagers(value) {
    this.searchTermManagers = value
  }

  setOrderStartCloseDateFilter(value) {
    this.order_start_close_date_filter = this.toISODateString(value)
    if (!this.order_end_close_date_filter) {
      this.setOrderEndCloseDateFilter(new Date())
    }
  }
  setOrderEndOpenDateFilter(value) {
    this.order_end_open_date_filter = this.toISODateString(value)
  }
  setOrderEndCloseDateFilter(value) {
    this.order_end_close_date_filter = this.toISODateString(value)
  }

  setSelectedBind(value) {
    this.selectedBind = value
  }
  toISODateString(date) {
    if (!date) return '';

    if (typeof date === 'string') {
      return date;
    }

    if (date instanceof Date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }

    return '';
  }


  resetPaymentFilters = () => {
    this.start_date_day = "";
    this.end_date_day = "";
    this.start_date_month = "";
    this.end_date_month = "";
    this.start_date_year = "";
    this.end_date_year = "";
    this.selected_one_department = "";
    this.updateSelectedManagers([])
    this.getAllManagers().catch(error => console.error("Ошибка при получении менеджеров:", error));
    this.selected_organization = ""
    this.select_backup = ""
    this.backup_status = "idle"
    this.backup_message = ""
    this.selected_staff_years = ""
    this.searchTermManagers = ""
    this.setSelectedBind("")
    this.year_or_mouth_view = 'month'
  }

  resetOrderSupplierFilters = () => {
    this.start_date_day = "";
    this.end_date_day = "";
    this.start_date_month = "";
    this.end_date_month = "";
    this.start_date_year = "";
    this.end_date_year = "";
    this.selected_one_department = "";
    this.updateSelectedManagers([])
    this.getAllManagers().catch(error => console.error("Ошибка при получении менеджеров:", error));
    this.select_backup = ""
    this.backup_status = "idle"
    this.backup_message = ""
    this.selected_staff_years = ""
    this.searchTermManagers = ""
    this.setSelectedBind("")
    // специфичные для отчёта «Заказ поставщику»
    this.os_internal_code_filter  = ""
    this.os_payment_code_filter   = ""
    this.os_id_deal_filter        = ""
    this.os_account_num_1c_filter = ""
    this.os_legal_entity_filter   = ""
    this.os_stage_filter          = ""
  }

  resetFilters = () => {
    this.start_date_day = "";
    this.end_date_day = "";
    this.start_date_month = "";
    this.end_date_month = "";
    this.start_date_year = "";
    this.end_date_year = "";
    this.selected_one_department = "";
    this.updateSelectedManagers([])
    this.getAllManagers().catch(error => console.error("Ошибка при получении менеджеров:", error));
    this.selected_organization = "";
    this.selected_one_agent = "";
    this.selected_agents = [];
    this.selected_one_account_number = ""
    this.selected_view_orders = 'all'
    this.selected_view = 'manager-deals'
    this.year_or_mouth_view = 'month'
    this.year_or_mouth_view_mops = 'month'
    this.selected_period = ""
    this.selected_period_potential = ""
    this.setOrderTypeDateStartFilter("none")
    this.setOrderTypeDateEndFilter("none")
    this.setOrderTypeDzDateFilter("none")
    this.setOrderTypeCargoReadyFilter("none")
    this.setOrderTypeDateAtClientFilter("none")
    this.setOrderTypeShipmentDateFilter("none")
    this.setOrderNumFilter("")
    this.order_start_open_date_filter = ""
    this.order_start_close_date_filter = ""
    this.order_end_open_date_filter = ""
    this.order_end_close_date_filter = ""
    this.order_start_dz_date_filter = ""
    this.order_end_dz_date_filter = ""
    this.order_start_cargo_ready_filter = ""
    this.order_end_cargo_ready_filter = ""
    this.order_start_date_at_client_filter = ""
    this.order_end_date_at_client_filter = ""
    this.order_start_shipment_date_filter = ""
    this.order_end_shipment_date_filter = ""
    this.setOrderShipmentPercentFilters({})
    this.selected_staff_years = ""
    this.select_backup = ""
    this.backup_status = "idle"
    this.backup_message = ""
    this.searchTermManagers = ""
    this.setSelectedBind("")
  }

  resetProfitFilters = () => {
    this.selected_period_month = []
    this.selected_period_years = []
    this.updateSelectedManagers([])
    this.selected_one_department = ""
    this.getAllManagers().catch(error => console.error("Ошибка при получении менеджеров:", error));
    this.selected_type_leads = ""
    this.selected_view_profit = 'manager-deals'
    this.selected_staff_years = ""
    this.select_backup = ""
    this.backup_status = "idle"
    this.backup_message = ""
    this.searchTermManagers = ""
    this.updateSelectedCompany("")
    this.year_or_mouth_view = "month"
  }

  resetPotentialFilters = () => {
    this.selected_years = ""
    this.updateSelectedManagers([])
    this.selected_one_agent_potential = ""
    this.selected_one_department = ""
    this.getAllManagers().catch(error => console.error("Ошибка при получении менеджеров:", error));
    this.status_deal = "all"
    this.selected_one_account_number = ""
    this.group_by_potential = ""
    this.selected_staff_years = ""
    this.select_backup = ""
    this.backup_status = "idle"
    this.backup_message = ""
    this.searchTermManagers = ""
  }

  setRequestTime = (time) => {
    this.request_time = time;
  }

  // логика refresh в auth.js, refresh_token в localStorage не меняем
  refreshToken = async () => {
    // Общая логика refresh в auth.js (без перезаписи refresh_token в localStorage)
    const result = await refreshAccessToken();
    return Boolean(result?.jwt_token);
  }

  getAllManagers = async () => {
    try {
      let response;

      if (this.selected_one_department !== "") {
        response = await authFetch(
          `${baseUrl}/api/filters/users/${this.selected_one_department}`,
          {
            headers: {
              accept: "application/json",
              "X-Database": "main"
            },
          }
        );
      } else {
        response = await authFetch(`${baseUrl}/api/filters/users`, {
          headers: {
            accept: "application/json",
            "X-Database": "main"
          },
        });
      }

      const result = await response.json();
      if (!Array.isArray(result)) {
        this.all_managers = [];
        return;
      }

      runInAction(() => {
        this.all_managers = result.sort((a, b) =>
          a.fio.localeCompare(b.fio, "ru")
        );
      });

    } catch (e) {
      console.error("Ошибка при получении менеджеров:", e);
    }
  };

  getAllDepartments = async () => {
    const response = await authFetch(`${baseUrl}/api/filters/deps`, {
      method: "GET",
      headers: {
        accept: "application/json",
        "X-Database": "main"
      }
    })
    const result = await response.json()
    console.log("result dep", result)
    this.all_departments = Array.isArray(result) ? result : [];
  }

  getAllBackups = async () => {
    const response = await authFetch(`${baseUrl}/api/backups`, {
      method: "GET",
      headers: {
        accept: "application/json",
      }
    })
    const result = await response.json()
    console.log("result backups", result)
    if (!Array.isArray(result)) {
      this.all_backups = [];
      return;
    }
    this.all_backups = [...result].sort((a, b) => {
      const parseDate = (str) => {
        const [day, month, year] = str.split(".");
        return new Date(year, month - 1, day);
      };
      return parseDate(b) - parseDate(a);
    });
  }

  getReportBinds = async (report_name) => {
    const response = await authFetch(`${baseUrl}/api/binds?report=${report_name}`, {
      method: "GET",
      headers: {
        accept: "application/json",
      }
    })
    const result = await response.json()
    this.report_binds = Array.isArray(result) ? result : []
  }


  getAllPaysOrgs = async () => {
    const response = await authFetch(`${baseUrl}/api/filters/pays/orgs`, {
      method: "GET",
      headers: {
        accept: "application/json",
        "X-Database": "main"
      }
    })
    const result = await response.json()
    console.log("orgs", result);
    this.all_orgs = Array.isArray(result) ? result : [];
  }

  getAllOrderSupplierLegalEntities = async () => {
    const response = await authFetch(`${baseUrl}/api/filters/order_suppliers/legal_entities`, {
      method: "GET",
      headers: {
        accept: "application/json",
        "X-Database": "main"
      }
    })
    const result = await response.json()
    this.all_order_supplier_legal_entities = Array.isArray(result) ? result : []
  }

  getAllOrderSupplierStages = async () => {
    const response = await authFetch(`${baseUrl}/api/filters/order_suppliers/stages`, {
      method: "GET",
      headers: {
        accept: "application/json",
        "X-Database": "main"
      }
    })
    const result = await response.json()
    this.all_order_supplier_stages = Array.isArray(result) ? result : []
  }
  getAllPartners = async () => {
    const response = await authFetch(`${baseUrl}/api/filters/orders/partners`, {
      method: "GET",
      headers: {
        accept: "application/json",
        "X-Database": "main"
      }
    })
    const result = await response.json();
    console.log("agents", result)
    this.all_agents = Array.isArray(result) ? result : [];
  }
  getAllPartnersPotential = async () => {
    const response = await authFetch(`${baseUrl}/api/filters/potential/partners`, {
      method: "GET",
      headers: {
        accept: "application/json",
        "X-Database": "main"
      }
    })
    const result = await response.json();
    console.log("agents", result)
    this.all_agents_potential = Array.isArray(result) ? result : [];
  }
  getAllAccountNumbers = async () => {
    const response = await authFetch(`${baseUrl}/api/filters/orders/nums`, {
      method: "GET",
      headers: {
        accept: "application/json",
        "X-Database": "main"
      }
    })
    const result = await response.json()
    console.log("numbers", result)
    this.all_account_numbers = Array.isArray(result) ? result : [];
  }
  getAllPromos = async () => {
    const response = await authFetch(`${baseUrl}/api/filters/profits/promos`, {
      method: "GET",
      headers: {
        accept: "application/json",
        "X-Database":  "main"
      }
    })
    const result = await response.json();
    console.log("promos", result);
    this.all_companies = Array.isArray(result) ? result : [];
  }
  getAllPeriods = async () => {
    try {
      const response = await authFetch(`${baseUrl}/api/filters/profits/dates`, {
        method: "GET",
        headers: {
          accept: "application/json",
          "X-Database": "main"
        }
      });
      const result = await response.json();
      // API возвращает { mouths, years }, не массив
      this.all_periods =
        result && typeof result === "object" && !Array.isArray(result)
          ? result
          : { mouths: [], years: [] };
    } catch (e) {
      console.error("getAllPeriods:", e.message);
      this.all_periods = { mouths: [], years: [] };
    }
  }

  getAllYears = async () => {
    const response = await authFetch(`${baseUrl}/api/filters/potential/years`, {
      method: "GET",
      headers: {
        accept: "application/json",
        "X-Database": "main"
      }
    })
    const result = await response.json()
    this.all_years = Array.isArray(result) ? result : []
  }

  getAllRoles = async () => {
    const response = await authFetch(`${baseUrl}/api/roles`, {
      method: "GET",
      headers: {
        accept: "application/json",
        "X-Database": "main"
      },
    });
    const result = await response.json();
    this.roles = Array.isArray(result) ? result.sort((a, b) => a?.id - b?.id) : [];
  };
  CheckPermission = async (permission) => {
    const query = new URLSearchParams();
    query.append("permission_name", permission)
    const response = await authFetch(`${baseUrl}/api/permissions/check?${query}`, {
      method: "GET",
      headers: {
        accept: "application/json",
      },
    });
    const result = await response.json();
    if (Array.isArray(result) && result.length !== 0) {
      return true
    } else {
      return false
    }
  }
  getLogs = async (date_from, date_to) => {
    const response = await authFetch(`${baseUrl}/api/logs?date_from=${date_from}&date_to=${date_to}`, {
      method: "GET",
      headers: {
        accept: "application/json",

      }
    })
    const result = await response.json()
    this.data_logs = result;
  }


  editActiveColumns = async (report, columns) => {
    console.log(columns)
    const response = await authFetch(`${baseUrl}/api/edit_active_columns`, {
      method: "POST",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        "active": (columns || [])
          .filter(col => col.active)
          .map(col => col.key),
        "order": (columns || []).map(col => col.key),
        "report": report,
      })
    })
    return response
  }

  updateSelectedBackupServer = async () => {
    const response = await authFetch(`${baseUrl}/api/edit_active_backup?backup_date=${this.select_backup}`, {
      method: "POST",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    return await response.json()
  }

  saveBind = async (report, name) => {
    const filters = {
      "selected_one_manager": this.selected_one_manager,
      "selected_one_department": this.selected_one_department,
      "select_backup": this.select_backup,
      "selected_view_orders": this.selected_view_orders,
      "selected_view": this.selected_view,
      "selected_view_profit": this.selected_view_profit,
      "selected_view_open": this.selected_view_open,
      "selected_view_pdz": this.selected_view_pdz,
      "year_or_mouth_view": this.year_or_mouth_view,
      "year_or_mouth_view_mops": this.year_or_mouth_view_mops,
      "start_date_day": this.start_date_day,
      "start_date_month": this.start_date_month,
      "start_date_year": this.start_date_year,
      "selected_managers": this.selected_managers,
      "selected_organization": this.selected_organization,
      "end_date_day": this.end_date_day,
      "end_date_month": this.end_date_month,
      "end_date_year": this.end_date_year,
      "selected_period": this.selected_period,
      "selected_one_agent": this.selected_one_agent,
      "selected_one_agent_potential": this.selected_one_agent_potential,
      "selected_one_account_number": this.selected_one_account_number,
      "selected_period_month": this.selected_period_month,
      "selected_period_years": this.selected_period_years,
      "select_one_company": this.select_one_company,
      "selected_staff_years": this.selected_staff_years,
      "selected_years": this.selected_years,
      "status_deal": this.status_deal,
      "selected_type_leads": this.selected_type_leads,
      "group_by_potential": this.group_by_potential,
      "order_num_filter": this.order_num_filter,
      "order_deal_filter": this.order_deal_filter,
      "order_type_date_start_filter": this.order_type_date_start_filter,
      "order_type_date_end_filter": this.order_type_date_end_filter,
      "order_start_open_date_filter": this.order_start_open_date_filter,
      "order_end_open_date_filter": this.order_end_open_date_filter,
      "order_start_close_date_filter": this.order_start_close_date_filter,
      "order_end_close_date_filter": this.order_end_close_date_filter,
      "order_type_dz_date_filter": this.order_type_dz_date_filter,
      "order_start_dz_date_filter": this.order_start_dz_date_filter,
      "order_end_dz_date_filter": this.order_end_dz_date_filter,
      "order_type_cargo_ready_filter": this.order_type_cargo_ready_filter,
      "order_start_cargo_ready_filter": this.order_start_cargo_ready_filter,
      "order_end_cargo_ready_filter": this.order_end_cargo_ready_filter,
      "order_type_date_at_client_filter": this.order_type_date_at_client_filter,
      "order_start_date_at_client_filter": this.order_start_date_at_client_filter,
      "order_end_date_at_client_filter": this.order_end_date_at_client_filter,
      "order_type_shipment_date_filter": this.order_type_shipment_date_filter,
      "order_start_shipment_date_filter": this.order_start_shipment_date_filter,
      "order_end_shipment_date_filter": this.order_end_shipment_date_filter,
      "order_shipment_percent_filters": this.order_shipment_percent_filters,
      "isSelf": this.isSelf,
      "isFail": this.isFail,
      "isReturn": this.isReturn,
      "month_and_year_fromB24": this.month_and_year_fromB24,
      "month_and_year_fromProfit": this.month_and_year_fromProfit,
      "month_and_year_from1C": this.month_and_year_from1C,
      "absolute_column_profit": this.absolute_column_profit,
      "percent_column_profit": this.percent_column_profit,
      "part_column_profit": this.part_column_profit,
      "absolute_column_payments": this.absolute_column_payments,
      "percent_column_payments": this.percent_column_payments,
      "part_column_payments": this.part_column_payments,
      "absolute_column_openRev": this.absolute_column_openRev,
      "percent_column_openRev": this.percent_column_openRev,
      "part_column_openRev": this.part_column_openRev,
      "absolute_column_openProfit": this.absolute_column_openProfit,
      "percent_column_openProfit": this.percent_column_openProfit,
      "part_column_openProfit": this.part_column_openProfit,
      "absolute_column_mops": this.absolute_column_mops,
      "percent_column_mops": this.percent_column_mops,
      "part_column_mops": this.part_column_mops,
      "workers": this.workers,
      "open_filter": this.open_filter,
      "os_internal_code_filter": this.os_internal_code_filter,
      "os_payment_code_filter": this.os_payment_code_filter,
      "os_id_deal_filter": this.os_id_deal_filter,
      "os_account_num_1c_filter": this.os_account_num_1c_filter,
      "os_legal_entity_filter": this.os_legal_entity_filter,
      "os_stage_filter": this.os_stage_filter,
      "columns": ({
        "payments": this.columnConfigPayments,
        "openRev": this.columnConfigOpenRev,
        "openProfit": this.columnConfigOpenProfit,
        "staff": this.columnConfigStaff,
        "pdz": this.columnConfigPDZ,
        "debitor": this.columnConfigDebitor,
        "potential": this.columnConfigPotential,
        "orderSuppliers": this.columnConfigOrderSuppliers
      })[report]
    }
    const reponse = await authFetch(`${baseUrl}/api/bind_add`, {
      method: "POST",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        "report": report,
        "bind_name": name,
        "filters": filters
      })
    })
    return reponse
  }

  deleteBind = async (report, name) => {
    const response = await authFetch(`${baseUrl}/api/bind_delete?report=${report}&bind_name=${name}`, {
      method: "POST",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    return response
  }

  updateSelectedBind = async (report, name) => {
    console.log(report)
    console.log(name)
    this.setSelectedBind(name)

    if (name == "") {
      switch (report) {
        case "payments": this.resetPaymentFilters();
        case "staff": this.resetFilters();
        case "openRev": this.resetFilters();
        case "openProfit": this.resetFilters();
        case "pdz": this.resetFilters();
        case "debitors": this.resetFilters();
        case "mops": this.resetFilters();
        case "potential": this.resetPotentialFilters();
        case "profit": this.resetProfitFilters();
        case "orderSuppliers": this.resetOrderSupplierFilters();
        default: this.resetFilters();
      }
      return
    }
    const bind = this.report_binds.find(bind => bind.bind_name === name)?.filters
    if (bind) {
      this.updateSelectedOneManager(bind.selected_one_manager);
      this.updateSelectedOneDepartment(bind.selected_one_department);
      this.updateSelectedBackup(bind.select_backup);
      this.updateSelectedViewOrders(bind.selected_view_orders);
      this.updateSelectedView(bind.selected_view)
      this.updateSelectedViewProfit(bind.selected_view_profit)
      this.updateSelectedViewOpen(bind.selected_view_open);
      this.updateSelectedViewPDZ(bind.selected_view_pdz)
      this.updateYearOrMouthView(bind.year_or_mouth_view)
      this.updateYearOrMouthViewMOPS(bind.year_or_mouth_view_mops)
      this.updateStartDateDay(bind.start_date_day)
      this.updateEndDateDay(bind.end_date_day)
      this.updateStartDateMonth(bind.start_date_month)
      this.updateEndDateMonth(bind.end_date_month)
      this.updateEndDateYear(bind.end_date_year)
      this.updateStartDateYear(bind.start_date_year)
      this.updateSelectedManagers(bind.selected_managers)
      this.updateSelectedOrganiztion(bind.selected_organization)
      this.updateSelectedPeriod(bind.selected_period, "bind")
      this.updateSelectedAgent(bind.selected_one_agent)
      this.updateSelectedAgentPotential(bind.selected_one_agent_potential)
      this.updateSelectedAccountNumber(bind.selected_one_account_number)
      this.updateSelectedPeriodMonth(bind.selected_period_month)
      this.updateSelectedPeriodYear(bind.selected_period_years)
      this.updateSelectedCompany(bind.select_one_company)
      this.updateSelectedStaffYears(bind.selected_staff_years)
      this.updateSelectedYears(bind.selected_years)
      this.updateStatusDeal(bind.status_deal)
      this.updateSelectedTypeLeads(bind.selected_type_leads)
      this.updateGroupByPotential(bind.group_by_potential)
      this.setOrderNumFilter(bind.order_num_filter)
      this.setOrderDealFilter(bind.order_deal_filter)
      this.setOrderTypeDateStartFilter(bind.order_type_date_start_filter)
      this.setOrderTypeDateEndFilter(bind.order_type_date_end_filter)
      this.setOrderTypeDzDateFilter(bind.order_type_dz_date_filter ?? "none")
      this.setOrderTypeCargoReadyFilter(bind.order_type_cargo_ready_filter ?? "none")
      this.setOrderTypeDateAtClientFilter(bind.order_type_date_at_client_filter ?? "none")
      this.setOrderTypeShipmentDateFilter(bind.order_type_shipment_date_filter ?? "none")
      this.setOrderStartOpenDateFilter(bind.order_start_open_date_filter)
      this.setOrderStartDzDateFilter(bind.order_start_dz_date_filter ?? "")
      this.setOrderEndDzDateFilter(bind.order_end_dz_date_filter ?? "")
      this.setOrderStartCargoReadyFilter(bind.order_start_cargo_ready_filter ?? "")
      this.setOrderEndCargoReadyFilter(bind.order_end_cargo_ready_filter ?? "")
      this.setOrderStartDateAtClientFilter(bind.order_start_date_at_client_filter ?? "")
      this.setOrderEndDateAtClientFilter(bind.order_end_date_at_client_filter ?? "")
      this.setOrderStartShipmentDateFilter(bind.order_start_shipment_date_filter ?? "")
      this.setOrderEndShipmentDateFilter(bind.order_end_shipment_date_filter ?? "")
      this.setOrderShipmentPercentFilters(bind.order_shipment_percent_filters)
      this.setMonthAndYearFromB24(bind.month_and_year_fromB24, "bind")
      this.setMonthAndYearFromProfit(bind.month_and_year_fromProfit, "bind")
      this.setMonthAndYearFrom1C(bind.month_and_year_from1C, "bind")
      this.setAbsoluteColumnProfit(bind.absolute_column_profit, "bind")
      this.setPercentColumnProfit(bind.percent_column_profit, "bind")
      this.setPartColumnProfit(bind.part_column_profit, "bind")
      this.setAbsoluteColumnOpenProfit(bind.absolute_column_openProfit, "bind")
      this.setPercentColumnOpenProfit(bind.percent_column_openProfit, "bind")
      this.setPartColumnOpenProfit(bind.part_column_openProfit, "bind")
      this.setAbsoluteColumnPayments(bind.absolute_column_payments, "bind")
      this.setPercentColumnPayments(bind.percent_column_payments, "bind")
      this.setPartColumnPayments(bind.part_column_payments, "bind")
      this.setAbsoluteColumnMops(bind.absolute_column_mops, "bind")
      this.setPercentColumnMops(bind.percent_column_mops, "bind")
      this.setPartColumnMops(bind.part_column_mops, "bind")
      this.setAbsoluteColumnOpenRev(bind.absolute_column_openRev, "bind")
      this.setPercentColumnOpenRev(bind.percent_column_openRev, "bind")
      this.setPartColumnOpenRev(bind.part_column_openRev, "bind")
      this.setWorkers(bind.workers, "bind")
      this.setOpenFilters(bind.open_filter, "bind")
      this.setOrderStartCloseDateFilter(bind.order_start_close_date_filter)
      this.setOrderEndOpenDateFilter(bind.order_end_open_date_filter)
      this.setOrderEndCloseDateFilter(bind.order_end_close_date_filter)
      this.setIsSelf(bind.isSelf, "bind")
      this.setIsFail(bind.isFail, "bind")
      this.setIsReturn(bind.isReturn, "bind")
      // фильтры отчёта «Заказ поставщику»
      this.setOsInternalCodeFilter(bind.os_internal_code_filter ?? "")
      this.setOsPaymentCodeFilter(bind.os_payment_code_filter ?? "")
      this.setOsIdDealFilter(bind.os_id_deal_filter ?? "")
      this.setOsAccountNum1CFilter(bind.os_account_num_1c_filter ?? "")
      this.setOsLegalEntityFilter(bind.os_legal_entity_filter ?? "")
      this.setOsStageFilter(bind.os_stage_filter ?? "")

      if (bind.columns) {
        const configHandlers = {
          payments: () => this.setColumnConfigPayments(bind.columns),
          staff: () => this.setColumnConfigStaff(bind.columns),
          openRev: () => this.setColumnConfigOpenRev(bind.columns),
          // Привязки, сохранённые до появления «ИНН / УНП», хранят список
          // колонок без него: без дописывания столбец пропадал бы из меню.
          openProfit: () => this.setColumnConfigOpenProfit(placeMissingColumns(bind.columns, this.columnConfigOpenProfit)),
          pdz: () => this.setColumnConfigPDZ(bind.columns),
          debitor: () => this.setColumnConfigDebitor(placeMissingColumns(bind.columns, this.columnConfigDebitor)),
          potential: () => this.setColumnConfigPotential(placeMissingColumns(bind.columns, this.columnConfigPotential)),
          profit: () => this.setColumnConfigProfit(bind.columns),
          orderSuppliers: () => this.setColumnConfigOrderSuppliers(bind.columns)
        };

        if (configHandlers[report]) {
          configHandlers[report]();
        }
      }
    }
  }
}

export default pageStore;
